export default {
  PageTitle: `Próximamente`,
  MarketingTitle: `¡Próximamente desde Texas.gov!`,
  MarketingSubtitle: `Estamos haciendo que los negocios estatales sean más fáciles, más rápidos y más seguros para todos los Tejanos.`,
  MarketingContent: `<p>Si bien tenemos grandes planes para el futuro cercano, estamos comenzando con un lanzamiento para que el Departamento de Licencias y Regulaciones de Tejas haga que la renovación de licencias profesionales sea más simple y eficiente.</p><p>Por favor, vuelva pronto para obtener más información.</p>`,
};
